/** Session / chapter cost display helpers (list-rate estimates only). */

export const ASSUMED_WORDS_PER_MINUTE = 500;
export const DEFAULT_CHAPTER_WORDS = 2000;

export function costUsdForWords(
  pricePerHour: number,
  words: number,
  wordsPerMinute = ASSUMED_WORDS_PER_MINUTE
): number {
  const rate = Math.max(0, Number(pricePerHour) || 0);
  const w = Math.max(0, Number(words) || 0);
  if (!(rate > 0) || !(w > 0) || !(wordsPerMinute > 0)) return 0;
  const minutes = w / wordsPerMinute;
  return (minutes / 60) * rate;
}

export function costUsdPer1kWords(pricePerHour: number): number {
  return costUsdForWords(pricePerHour, 1000);
}

export function chapterEstUsd(
  words: number,
  pricePerHour: number
): number | null {
  const rate = Number(pricePerHour) || 0;
  if (!(rate > 0)) return null;
  const w = words > 0 ? words : DEFAULT_CHAPTER_WORDS;
  return Math.ceil(costUsdForWords(rate, w) * 1000) / 1000;
}


